var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _ellipse2, _path7, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetstartedClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8712 4.68276C38.1917 3.34301 41.0507 3.34301 43.3712 4.68276L68.1277 18.9759C70.4482 20.3157 71.8777 22.7916 71.8777 25.4711V54.0574C71.8777 56.7369 70.4482 59.2129 68.1277 60.5526L43.3712 74.8458C41.0507 76.1856 38.1917 76.1856 35.8712 74.8458L11.1147 60.5526C8.79422 59.2129 7.36473 56.7369 7.36473 54.0574V25.4711C7.36473 22.7916 8.79422 20.3157 11.1147 18.9759L35.8712 4.68276Z",
    fill: "white",
    stroke: "#ACD0D2",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9962 8.16282C38.6205 7.225 40.6218 7.225 42.2462 8.16282L65.6763 21.6902C67.3007 22.628 68.3013 24.3612 68.3013 26.2368V53.2916C68.3013 55.1673 67.3007 56.9004 65.6763 57.8383L42.2462 71.3657C40.6218 72.3035 38.6205 72.3035 36.9962 71.3657L13.566 57.8383C11.9417 56.9004 10.941 55.1673 10.941 53.2916V26.2368C10.941 24.3612 11.9417 22.628 13.566 21.6902L36.9962 8.16282Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9962 8.16282C38.6205 7.225 40.6218 7.225 42.2462 8.16282L65.6763 21.6902C67.3007 22.628 68.3013 24.3612 68.3013 26.2368V53.2916C68.3013 55.1673 67.3007 56.9004 65.6763 57.8383L42.2462 71.3657C40.6218 72.3035 38.6205 72.3035 36.9962 71.3657L13.566 57.8383C11.9417 56.9004 10.941 55.1673 10.941 53.2916V26.2368C10.941 24.3612 11.9417 22.628 13.566 21.6902L36.9962 8.16282Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9962 8.16282C38.6205 7.225 40.6218 7.225 42.2462 8.16282L65.6763 21.6902C67.3007 22.628 68.3013 24.3612 68.3013 26.2368V53.2916C68.3013 55.1673 67.3007 56.9004 65.6763 57.8383L42.2462 71.3657C40.6218 72.3035 38.6205 72.3035 36.9962 71.3657L13.566 57.8383C11.9417 56.9004 10.941 55.1673 10.941 53.2916V26.2368C10.941 24.3612 11.9417 22.628 13.566 21.6902L36.9962 8.16282Z",
    stroke: "#3ABE5F",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8528 43.5376C48.8528 40.2239 51.5391 37.5376 54.8528 37.5376H58.5248C61.8385 37.5376 64.5248 40.2239 64.5248 43.5376V48.0927C64.5248 48.4969 64.2814 48.8615 63.9079 49.0164L48.8528 55.2605V49.3128V43.5376Z",
    fill: "#7FC1B5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.6888,
    cy: 31.7134,
    rx: 4.96634,
    ry: 4.99811,
    fill: "#7FC1B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3894 43.5376C30.3894 40.2239 27.7031 37.5376 24.3894 37.5376H20.7174C17.4037 37.5376 14.7174 40.2239 14.7174 43.5376V48.2727C14.7174 48.6807 14.9653 49.0478 15.3438 49.2003L30.3894 55.2605V49.3128V43.5376Z",
    fill: "#7FC1B5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.96634,
    cy: 4.99811,
    rx: 4.96634,
    ry: 4.99811,
    transform: "matrix(-1 0 0 1 27.5195 26.7153)",
    fill: "#7FC1B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8706 57.0842L50.2505 56.8889V56.4617V40.1187C50.2505 36.4183 47.2508 33.4187 43.5505 33.4187H35.6919C31.9916 33.4187 28.9919 36.4183 28.9919 40.1187V56.4617V56.8901L29.3734 57.085L37.5077 61.2416C38.8546 61.9298 40.4504 61.9278 41.7955 61.2362L49.8706 57.0842Z",
    fill: "#476876",
    stroke: "white",
    strokeWidth: 1.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.6212,
    cy: 26.7576,
    rx: 6.29304,
    ry: 6.3333,
    fill: "#476876"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetstartedClients);
export default __webpack_public_path__ + "static/media/getstarted-clients.63847ec039eeffae3d80db686832dc8b.svg";
export { ForwardRef as ReactComponent };